export default [
    {
        comment: '',
        error_id: 'T-XS-01',
        data: [
            {cross_section: '4420', dsrl: 520, side: 'left'},
            {cross_section: '4550', dsrl: 640, side: 'left'},
            {cross_section: '4650', dsrl: 482, side: 'right'},
            {cross_section: '4750', dsrl: 800, side: 'left'},
        ]
    },
    {
        comment: '',
        error_id: 'XS-02',
        data: [
            {
                "cross_section": "117000",
                "profile": "FW",
                "headloss": 3.55
            },
            {
                "cross_section": "117000",
                "profile": "100yr (1%)",
                "headloss": 3.22
            },
            {
                "cross_section": "115459",
                "profile": "FW",
                "headloss": 3.31
            },
            {
                "cross_section": "115459",
                "profile": "100yr (1%)",
                "headloss": 2.77
            }
        ]
    },
    {
        comment: '',
        error_id: 'XS-03',
        data: [
            {
                "cross_section": "117000",
                "profile": "FW",
                "headloss": 1.73
            },
            {
                "cross_section": "117000",
                "profile": "100yr (1%)",
                "headloss": 1.55
            },
            {
                "cross_section": "116000",
                "profile": "FW",
                "headloss": 0.56
            },
            {
                "cross_section": "116000",
                "profile": "100yr (1%)",
                "headloss": 0.33
            },
            {
                "cross_section": "115459",
                "profile": "FW",
                "headloss": 1.01
            },
            {
                "cross_section": "115459",
                "profile": "100yr (1%)",
                "headloss": 0.94
            },
            {
                "cross_section": "115000",
                "profile": "FW",
                "headloss": 0.45
            },
            {
                "cross_section": "115000",
                "profile": "100yr (1%)",
                "headloss": 0.55
            },
            {
                "cross_section": "114500",
                "profile": "FW",
                "headloss": 1.4
            },
            {
                "cross_section": "114500",
                "profile": "100yr (1%)",
                "headloss": 1.32
            },
            {
                "cross_section": "114000",
                "profile": "FW",
                "headloss": 1.28
            }
        ]
    },
    {
        comment: '',
        error_id: 'XS-04',
        data: [
            {
                "cross_section": "117000",
                "profile": "FW",
                "headloss": 0.51
            },
            {
                "cross_section": "116459",
                "profile": "FW",
                "headloss": 1.15
            },
            {
                "cross_section": "116459",
                "profile": "100yr (1%)",
                "headloss": 0.67
            },
            {
                "cross_section": "115000",
                "profile": "FW",
                "headloss": 1.14
            },
            {
                "cross_section": "115000",
                "profile": "100yr (1%)",
                "headloss": 0.73
            },
            {
                "cross_section": "114000",
                "profile": "FW",
                "headloss": 0.76
            }
        ]
    },
]